
export class BtnRadioGroupViewModel {
	constructor (params) {
		this._value = params.value;
		this._btnGroupAdaptive = params.bsBtnGroupAdaptive;
		this.btnGroup = params.btnGroup || {};
	}
}
